import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo.vue";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "async",
      description: "是否异步获取数据",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "initGet",
      description: "初始化时是否立即获取数据",
      type: "Boolean",
      default: "true"
    },
    {
      prop: "fullContainer",
      description: "是否撑满父级容器",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "sortMethod",
      description: "当async为false生效，自定义排序"
    },
    {
      prop: "sortClearPage",
      description: "当排序变化后，当前页是否设为1",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "total",
      description: "当async为false生效，同Pagination组件"
    },
    {
      prop: "BaseTable组件参数",
      description: "支持BaseTable的props"
    },
    {
      prop: "Pagination组件参数",
      description: "支持Pagination的props"
    }
  ],
  events: [
    {
      name: "pageChange",
      description: "当前页发生变化",
      argument: "当前页数"
    },
    {
      name: "getData",
      description: "当async为true时生效，当前页或者排序发生变化",
      argument: "当前页数、排序"
    },
    {
      name: "支持其他BaseTable事件"
    }
  ],
  methods: [
    {
      name: "clear",
      description: "清除排序和过滤，若async为true，则触发getData"
    }
  ],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
